import {BrowserRouter as Router, Route, Routes, Navigate} from "react-router-dom";
import Home from "../pages/Home/Home";
import NotFound from "../pages/NotFound/NotFound";
import MainLayout from "../layouts/MainLayout";
import AuthRouter from "./AuthRouter";
import Players from "../pages/Players/Players";
import Coaches from "../pages/Coaches/Coaches";
import Teams from "../pages/Teams/Teams";
import Statuses from "../pages/Statuses/Statuses";
import {useAuth} from "../context/context";
import {MenuProvider} from "../context/context";
import Payments from "../pages/Payments/Payments";
import Dashboard from "../pages/Dashboard/Dashboard";
import FeeSuspensionForm from "../pages/Settings/Settings";
import ChangePassword from "../pages/ChangePassword/ChangePassword";

const AppRouter = () => {
    const {isAuthenticated} = useAuth();

    return (
        <MenuProvider>
            <Router>
                <Routes>
                    {!isAuthenticated ? (
                        <>
                            <Route path="/login/*" element={<AuthRouter/>}/>
                            {/*<Route path="*" element={<Navigate to="/login" replace/>}/>*/}
                            <Route path="/" element={<AuthRouter/>}/>
                            <Route path="*" element={<AuthRouter/>}/>
                        </>
                    ) : (
                        <>
                            <Route path="/" element={<MainLayout/>}>
                                {/*<Route index element={<Home/>}/>*/}
                                <Route path="/" element={<Navigate to="/players" replace/>}/>
                                <Route path="/players" element={<Players/>}/>
                                <Route path="/all-players" element={<Players/>}/>
                                <Route path="/coaches" element={<Coaches/>}/>
                                <Route path="/teams" element={<Teams/>}/>
                                <Route path="/statuses" element={<Statuses/>}/>
                                <Route path="/payments" element={<Payments/>}/>
                                <Route path="*" element={<NotFound/>}/>
                                <Route path="/login/*" element={<Navigate to="/" replace/>}/>
                                <Route path="/dashboard" element={<Dashboard/>}/>
                                <Route path="/billings" element={<FeeSuspensionForm/>} />
                                <Route path="/change-password" element={<ChangePassword/>} />
                            </Route>
                        </>
                    )}
                </Routes>
            </Router>
        </MenuProvider>
    );
};

export default AppRouter;
